(() => {
    const getShopifyMoneyFormat = () =>
        window.theme?.moneyFormat || null;

    const formatMoney = (amount) => {
        const moneyFormat = getShopifyMoneyFormat();
        const value = Number(amount);

        if (!Number.isFinite(value)) {
            return "";
        }

        if (moneyFormat) {
            const amountInCurrency = value / 100;

            const formatAmount = (
                decimals,
                decimalSeparator,
                thousandsSeparator
            ) => {
                const fixed = amountInCurrency.toFixed(decimals);
                const [integer, decimal] = fixed.split(".");

                const formattedInteger = integer.replace(
                    /\B(?=(\d{3})+(?!\d))/g,
                    thousandsSeparator
                );

                return decimal
                    ? `${formattedInteger}${decimalSeparator}${decimal}`
                    : formattedInteger;
            };

            const formats = {
                "{{amount}}": formatAmount(2, ".", ","),
                "{{amount_no_decimals}}": formatAmount(0, ".", ","),
                "{{amount_with_comma_separator}}": formatAmount(2, ",", "."),
                "{{amount_no_decimals_with_comma_separator}}":
                    formatAmount(0, ",", "."),
                "{{amount_with_apostrophe_separator}}":
                    formatAmount(2, ".", "'"),
                "{{amount_no_decimals_with_apostrophe_separator}}":
                    formatAmount(0, ".", "'"),
            };

            return Object.entries(formats).reduce(
                (result, [placeholder, formattedAmount]) =>
                    result.replaceAll(placeholder, formattedAmount),
                moneyFormat
            );
        }

        const currency = Shopify?.currency?.active;

        if (!currency) {
            return String(amount);
        }

        return new Intl.NumberFormat("en-SG", {
            style: "currency",
            currency,
            currencyDisplay: "narrowSymbol",
        }).format(value / 100);
    };

    window.Utils = {
        formatMoney,
    };
})();